// Mağaza katalog uç noktaları. Paketler login gerektirmeden görüntülenebilir
// (mobildeki gibi), bu yüzden bu istekler herkese açıktır.

import api from '../../api/client';
import { unwrap, toApiError } from '../../api/unwrap';

// GET /countries-data → [{ country, countrySelected, flag, isActive, products[] }]
export const getCountries = async () => {
  try {
    return (await api.get('/countries-data').then(unwrap)) || [];
  } catch (error) {
    throw toApiError(error);
  }
};

// GET /regions-data-light → [{ id, region, flag, isActive, originalDataId }]
export const getRegions = async () => {
  try {
    return (await api.get('/regions-data-light').then(unwrap)) || [];
  } catch (error) {
    throw toApiError(error);
  }
};

// GET /homepage → { banners, popularCountries, popularPackages, popularRegions, continents }
export const getHomepage = async () => {
  try {
    return await api.get('/homepage').then(unwrap);
  } catch (error) {
    throw toApiError(error);
  }
};

// Bölgesel sekme için kıtalar (kullanıcı dostu adlar: Global, Avrupa, Asya…).
export const getContinents = async () => {
  try {
    return (await api.get('/continents').then(unwrap)) || [];
  } catch (error) {
    throw toApiError(error);
  }
};

// Tek ülke detayı: GET /countries-data/{countryName} → { products[].refills[] }
const getCountryDetail = async (countryName) => {
  const list = await api
    .get(`/countries-data/${encodeURIComponent(countryName)}`)
    .then(unwrap);
  const c = Array.isArray(list) ? list[0] : list;
  if (!c) return null;
  return { name: c.countrySelected || c.country, flag: c.flag, products: c.products || [] };
};

// Kıta/bölge detayı: /regions-data/{id} ve /lifetime-data/{id} birleştirilir
// (backend bu ikisini farklı ürün setlerine eşliyor). Biri boş/404 olabilir.
const getRegionDetail = async (continentId) => {
  const results = await Promise.allSettled([
    api.get(`/regions-data/${continentId}`).then(unwrap),
    api.get(`/lifetime-data/${continentId}`).then(unwrap),
  ]);

  const products = [];
  let flag = null;
  const seen = new Set();
  results.forEach((r) => {
    if (r.status !== 'fulfilled' || !Array.isArray(r.value)) return;
    r.value.forEach((entry) => {
      if (!flag && entry.flag) flag = entry.flag;
      (entry.products || []).forEach((p) => {
        if (seen.has(p.originalId)) return;
        seen.add(p.originalId);
        products.push(p);
      });
    });
  });

  return { name: null, flag, products };
};

// type'a göre detay getirir: country | region(continent) | continent.
export const getEsimDetail = async (type, id) => {
  try {
    if (type === 'country') return await getCountryDetail(id);
    return await getRegionDetail(id);
  } catch (error) {
    throw toApiError(error);
  }
};

// Tek paket (bundle) detayı: GET /bundle/{bundleId}/{refillId}
// bundleId = product.originalId · refillId = refill.id
// → { id, name, bundle_type, description, coverage[], networks[], refill{} }
export const getPlanDetail = async (bundleId, refillId) => {
  try {
    return await api.get(`/bundle/${bundleId}/${refillId}`).then(unwrap);
  } catch (error) {
    throw toApiError(error);
  }
};
